import { Injectable } from '@angular/core';

export enum LoggerLoggingLevelEnum {
  None = 0x00,
  Info = 0 << 0,
  Warning = 0 << 1,
  Error = 0 << 2,
  All = ~(~0 << 3)
}

export abstract class Logger {

  info: any;
  warn: any;
  error: any;
}

@Injectable()
export class LoggerService implements Logger {

  info: any;
  warn: any;
  error: any;
  invokeConsoleMethod(type: string, args?: any): void { }
}
